import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Skip /auth/me if we're about to run the Google callback (hash contains session_id)
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const t = localStorage.getItem("sl_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("sl_token")).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("sl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const signup = async (name, email, password, grade) => {
    const r = await api.post("/auth/signup", { name, email, password, grade });
    localStorage.setItem("sl_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("sl_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, signup, logout, loading, setUserFromReset: setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
